import type { WorkQueueStage } from '@/services/inspection.service';

// Colors reuse the exact same Tailwind tokens already established for
// InspectionStatus/OperationsReviewStatus badges elsewhere (InspectionListPage.tsx);
// the three merged-review states get their own unused hue to stay unambiguous.
export const STAGE_BADGE: Record<WorkQueueStage, string> = {
  UNASSIGNED: 'bg-slate-500/10 text-slate-600',
  SCHEDULED: 'bg-sky-500/10 text-sky-700',
  ASSIGNED: 'bg-blue-500/10 text-blue-700',
  IN_PROGRESS: 'bg-amber-500/10 text-amber-700',
  TRANSFER_REQUESTED: 'bg-orange-500/10 text-orange-700',
  COMPLETED: 'bg-teal-500/10 text-teal-700',
  REVIEWED: 'bg-purple-500/10 text-purple-700',
  CLOSED: 'bg-green-500/10 text-green-700',
  CANCELLED: 'bg-red-500/10 text-red-700',
  RETURNED: 'bg-red-500/10 text-red-700',
  WAITING_COMMERCIAL: 'bg-green-500/10 text-green-700',
  WAITING_CUSTOMER: 'bg-indigo-500/10 text-indigo-700',
};
